import React, { useEffect } from 'react';
import { dispatch, useSelector } from '@state/store';
import { TourSearch } from './TourSearch';
import { Page, Keyable, TripTypes } from '@model/common';
import { DEFAULT_SORT_TYPE } from '@model/iceberg';
import { performNavigate, unsetPackageReferences } from '@state/slices/app';
import { fetchToursByType } from '@state/slices/algolia/algoliaSlice';
import { getSearchParams, getToursByType } from '@state/slices/search/tours/tourSearchSelectors';
import { unsetLeadInTourReferences, unsetTourFilters, unsetTourReferences } from '@state/slices/tours';
import { resetPaymentForm } from '@state/slices/payment/paymentFormSlice';
import { getAlgoliaStateAirports, getAlgoliaTourAirportsByType } from '@state/slices/algolia/algoliaSelectors';
import { getToursSearchUrlParams } from '@util/tours';

export interface TourSearchContainerProps {
  condensed?: boolean;
  isVisible: boolean;
  tripType: TripTypes;
}

export const TourSearchContainer = ({ condensed = false, isVisible, tripType }: TourSearchContainerProps) => {
  const searchParams = useSelector(getSearchParams(tripType));
  const tours = useSelector(getToursByType(tripType));
  const algoliaAirports = useSelector(getAlgoliaStateAirports);
  const tripTypeAirports = useSelector(getAlgoliaTourAirportsByType(tripType));

  useEffect(() => {
    if (isVisible && algoliaAirports.length && !tripTypeAirports.length) {
      dispatch(fetchToursByType(tripType));
    }
  }, [isVisible, algoliaAirports]);

  const handleOnClick = () => {
    const query = getToursSearchUrlParams({
      tripType,
      tours,
      searchParams: { ...searchParams, sort: DEFAULT_SORT_TYPE }
    }) as Keyable;
    dispatch(unsetLeadInTourReferences());
    dispatch(unsetTourReferences());
    dispatch(unsetPackageReferences());
    dispatch(unsetTourFilters());
    dispatch(resetPaymentForm());
    dispatch(
      performNavigate({
        pathname: Page.TOURS_SEARCH,
        query
      })
    );
  };

  return <TourSearch tripType={tripType} isCondensed={condensed} isVisible={isVisible} onClick={handleOnClick} />;
};
